<template>
  <div class="w-full md:flex md:justify-center md:py-10 relative">
    <section>
      <div class="">
        <div class="fixed top-0 left-0 w-full h-full bg-gray-100 -z-10"></div>
        <div
          class="absolute left-0 bg-gradient-to-b from-[#0F2377] to-[#00102F] h-[220px] md:h-[320px] w-full -z-10 md:rounded-b-[40px]"
        ></div>
        <section
          class="w-full max-w-7xl mx-auto px-5 py-2 2xl:pt-5 md:p-4 lg:p-0"
        >
          <div class="flex flex-col md:gap-3 text-center">
            <h2 class="text-[#f8c300] font-semibold text-[24px] lg:text-[35px]">
              Our Placement Numbers
            </h2>
            <p class="text-white text-[14px] lg:text-[18px]">
              The numbers we present speak volumes.
            </p>
          </div>
          <div class="py-4">
            <div class="md:pt-5">
              <div
                class="flex flex-wrap gap-[10px] md:gap-[36px] justify-center"
              >
                <div
                  class="w-[155px] h-[135px] lg:w-[180px] lg:h-[230px]"
                  v-for="elective in electives"
                  :key="elective"
                >
                  <div
                    class="bg-white border rounded-xl shadow-lg md:rounded-3xl md:shadow-xl text-center flex flex-col gap-1 p-3 md:gap-3 md:p-5 items-center w-full h-full"
                  >
                    <div class="block md:hidden">
                      <img
                        :src="elective.imagesMob"
                        class="w-[33px] h-[42px] object-contain"
                        alt=""
                      />
                    </div>
                    <div class="hidden md:block">
                      <img
                        :src="elective.imagesDesk"
                        class="w-[66px] h-[79px] object-contain"
                        alt=""
                      />
                    </div>
                    <h2 class="text-[30px] text-black font-bold">
                      {{ elective.title }}
                    </h2>
                    <p class="text-[12px] md:text-[16px]">
                      {{ elective.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'KeyTakeaway',
  data() {
    return {
      electives: [
        {
          imagesMob: require('@/assets/electiveListing/Hiring-Corporates-Mobile.webp'),
          imagesDesk: require('@/assets/electiveListing/Hiring-Corporates-Mobile.webp'),
          title: '2000+',
          description: 'Hiring Corporates',
        },
        {
          imagesMob: require('@/assets/electiveListing/Group833.png'),
          imagesDesk: require('@/assets/electiveListing/Group833@2x.png'),
          title: '65%',
          description: 'Average Salary Hike',
        },
        {
          imagesMob: require('@/assets/electiveListing/Group874.png'),
          imagesDesk: require('@/assets/electiveListing/Group874@2x.png'),
          title: '78%',
          description: 'Career Success Rate',
        },
        {
          imagesMob: require('@/assets/electiveListing/Group836.png'),
          imagesDesk: require('@/assets/electiveListing/Group836@2x.png'),
          title: '15454+',
          description: 'Jobs Facilitated',
        },
        {
          imagesMob: require('@/assets/electiveListing/Group835.png'),
          imagesDesk: require('@/assets/electiveListing/Group835@2x.png'),
          title: '42 LPA',
          description: 'Highest Salary Offered ',
        },
        {
          imagesMob: require('@/assets/electiveListing/Career-Transitions-Mobile.webp'),
          imagesDesk: require('@/assets/electiveListing/Career-Transitions-Desktop.webp'),
          title: '21000+',
          description: 'Career Transitions',
        },
      ],
    }
  },
}
</script>

<style></style>
